
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[restaurantId]/widget",
      function () {
        return require("private-next-pages/[restaurantId]/widget/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[restaurantId]/widget"])
      });
    }
  